import React ,{useState ,useEffect} from 'react';
import StepFooter from 'components/presenters/footer/StepFooter'
import {Fitinfoarea, Fitinfotit, Fitinfosubtit,Textarea} from './style';
export default function ProjectSettingDescriptionStep({fitIntroductContent,infotext,placeholder,updateNext,setFitIntroductContent,title,projectInfo,setProjectInfo}) {
    const [next ,setNext] = useState(false);

    const projectInfoChange = (e) => {
         setProjectInfo(e.target.value);
         }
    const projectInfoVaildate = () =>{ return projectInfo.length > 2};

    useEffect(()=>{
    if(projectInfoVaildate())
            setNext(true);
    else
        setNext(false);
    },[projectInfo]);

    return(
        <Fitinfoarea>
            <Fitinfotit>{title}</Fitinfotit>
                <Fitinfosubtit>{infotext}</Fitinfosubtit>
            <Textarea 
                // value={fitIntroductContent} 
                onChange={projectInfoChange} 
                placeholder={placeholder}
                value={projectInfo}
            />

            {
                next?
                <StepFooter text={"2 / 5"}
                    color={"#7f7f7f"} 
                    position={"fixed"}
                    prevdisplay={"flex"}
                    nextdisplay={"flex"}
                    updateNext={updateNext}
                    next={next}
                />
                :
                <StepFooter text={"2 / 5"}
                    color={"#7f7f7f"} 
                    position={"fixed"}
                    prevdisplay={"flex"}
                    nextdisplay={"flex"}
                    updateNext={updateNext}
                    bg={"#d8d8d8"}
                    next={next}
                />
            }
            
     
        </Fitinfoarea>
    );
}
